export default __webpack_public_path__ + "static/media/foto00.93b60571.png";